"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
function MecanismNonApplicable({ explanation }) {
    return (jsx_runtime_1.jsxs(common_1.InfixMecanism, Object.assign({ prefixed: true, value: explanation.valeur }, { children: [jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "non applicable si", value: explanation.condition.nodeValue }, { children: jsx_runtime_1.jsx(Explanation_1.default, { node: explanation.condition }, void 0) }), void 0), jsx_runtime_1.jsx("br", {}, void 0)] }), void 0));
}
exports.default = MecanismNonApplicable;
